import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SittingInfo from "./SittingInfo";
import ConfirmationModal from "../../../../components/shareableContainer/ConfirmationModal";
import UnitInfo from "./UnitInfo";
import RoughPropertyInfoBasic from "../RoughPropertyInfoBasic";
import PropertyStepProgress from "../../../../components/common/PropertyStepProgress";
import CustomButton from "../../../../components/common/CustomButton";
import CustomHeading from "../../../../components/common/CustomHeading";
import Header from "../../../Header/Header";
import { ToastContainer } from "react-toastify";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/Constant/Notification";
import { userUid } from "../../../../utils/storage";
import RoughPropertyService from "../../../Service/RoughPropertyService";
import {
  formatDate,
  formatToIndianDate,
} from "../../../../utils/dateFormatter";
import ReusableSittingForm from "../../../OverallSittingManagement/ReusableSittingForm";
import SittingService from "../../../Service/SittingService";
import { availableId } from "../../../../Enum";

const RoughPropertyInfoPage = () => {
  const location = useLocation();
  const {
    propertyId,
    selectedPropertyDetails,
    propertySaleType,
    propertyTypeName,
    propertyName,
    propertyStage,
  
  } = location.state || { propertyId: null };
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [createdPropertyId, setCreatedPropertyId] = useState(
    propertyId || null
  );
  const navigate = useNavigate();

  console.log("location.state", location.state);

  const [showSittingForm, setShowSittingForm] = useState(false);
  const [editingSitting, setEditingSitting] = useState(null);
  const [formData, setFormData] = useState({
    stage: "",
    sittingTitle: "",
    sittingSpot: "",
    primarySittingPerson: "",
    secondarySittingPerson: "",
    meetingPersonType: "",
    meetingPersonName: "",
    sittingDate: "",
    sittingTime: "",
    otherNotes: "",
    status: "",
  });

  const [isProspectCreated, setIsProspectCreated] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [fullComeDate, setFullComeDate] = useState("");

  const [propertyInfo, setPropertyInfo] = useState({
    name: "",
    propertySaleType: propertySaleType || "",
    propertyType: selectedPropertyDetails?.id || "",
    propertyTypeName: selectedPropertyDetails?.label || "",
    propertyStage: propertyStage || "",
    noOfUnits: "",
    propertyEnteredDate: "",
    overAllArea: "",
    areaType: "sqft",
    ratePerSqft: "",
    rateInNumber: "",
    overAllBudget: "",
    location: "",
    village: "",
    vendorName: "",
    vendorCountryCode: "91",
    vendorPhoneNumber: "",
    mediatorName: "",
    mediatorCountryCode: "91",
    mediatorPhoneNumber: "",
    traderName: "",
    traderCountryCode: "91",
    traderPhoneNumber: "",
    images: [],
    driveLink: "",
    sketchLink: "",
    attachedLink: "",
    notes: "",
    purchaseType: "",
    createdById: userUid || "",
    address: "",
    locationLink: "",
    locationLatitude: "",
    locationLongitude: "",
    primarySourcedBy: "",
    secondarySourcedBy: "",
    geoLocation: "",
    overAllSqft: "",
    overAllCent: "",
    overAllGround: "",
    overAllAcre: "",
    areaRate: "",

  });

  const [units, setUnits] = useState([]);
  const [unitTotal, setUnitTotal] = useState(0);

  const formatINR = (value) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(value);
  };

  const formatINRShort = (value) => {
    if (value >= 10000000) return (value / 10000000).toFixed(2) + " Cr";
    if (value >= 100000) return (value / 100000).toFixed(2) + " L";
    if (value >= 1000) return (value / 1000).toFixed(2) + " K";
    return value.toString();
  };

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "available":
        return "text-green-600";
      case "sold":
        return "text-red-600";
      case "booked":
        return "text-yellow-600";
      default:
        return "text-gray-600";
    }
  };

  const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        updated.locationLink =
          coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])
            ? `https://www.google.com/maps?q=${coords[0]},${coords[1]}`
            : "";
      }
      return updated;
    });
  };

  const handleArrayFieldChange = (fieldName, values) => {
    setPropertyInfo((prev) => ({ ...prev, [fieldName]: values }));
  };

  const handleAddUnit = useCallback(
    (unit) => {
      // Generate a unique local identifier for new units
      const localId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      
      const newUnit = {
        ...unit,
        id: null, // Explicitly set to null for new units
        localId: localId, // Add local identifier for tracking
        order: units.length + 1,
        isLocallyCreated: true, // Mark as locally created
      };
      
      console.log("Adding new unit to local state:", newUnit);
      setUnits((prev) => [...prev, newUnit]);
    },
    [units]
  );

  const handleEditUnit = useCallback((updatedUnit) => {
    console.log("Editing unit:", updatedUnit);
    console.log("Current units:", units);
    
    setUnits((prev) => {
      const updatedUnits = prev.map((unit) => {
        // First priority: match by real ID
        if (unit.id && updatedUnit.originalId && unit.id === updatedUnit.originalId) {
          console.log("Matched by real ID:", unit.id);
          return { ...updatedUnit, id: unit.id, isLocallyCreated: false };
        }
        // Second priority: match by localId
        else if (unit.localId && updatedUnit.originalLocalId && unit.localId === updatedUnit.originalLocalId) {
          console.log("Matched by localId:", unit.localId);
          return { ...updatedUnit, localId: unit.localId, isLocallyCreated: true };
        }
        // Third priority: match by current localId if it exists
        else if (unit.localId && updatedUnit.localId && unit.localId === updatedUnit.localId) {
          console.log("Matched by current localId:", unit.localId);
          return { ...updatedUnit, isLocallyCreated: true };
        }
        // Fourth priority: match by current ID
        else if (unit.id && updatedUnit.id && unit.id === updatedUnit.id) {
          console.log("Matched by current ID:", unit.id);
          return { ...updatedUnit, isLocallyCreated: false };
        }
        
        return unit;
      });
      
      console.log("Updated units:", updatedUnits);
      return updatedUnits;
    });
  }, [units]);

  const fetchGetPropertyById = useCallback(async (id) => {
    try {
      setLoading(true);
      const response = await RoughPropertyService.getRoughPropertyId(id);
      if (response.status === 200) {
        const data = response.data?.data || {};
        let geoLocationValue = "";
        if (data.locationLatitude && data.locationLongitude) {
          geoLocationValue = `${data.locationLatitude}, ${data.locationLongitude}`;
        } else if (data.driveLink) {
          const coordsMatch = data.driveLink.match(
            /q=(-?\d+\.?\d*),(-?\d+\.?\d*)/
          );
          if (coordsMatch) {
            geoLocationValue = `${coordsMatch[1]}, ${coordsMatch[2]}`;
          }
        }

        setPropertyInfo((prev) => ({
          ...prev,
          name: data.name || "",
          propertySaleType: data.propertySaleType?.name || "",
          propertyType: data.propertyType?.id || "",
          propertyTypeName: data.propertyType?.name || "",
          noOfUnits: data.noOfUnits || "",
          propertyEnteredDate: formatDate(data.propertyEnteredDate) || "",
          overAllArea: data.overAllArea || "",
          areaType: data.areaType || "",
          ratePerSqft: data.ratePerSqft || "",
          rateInNumber: data.rateInNumber || "",
          overAllBudget: data.overAllBudget || "",
          propertyStage: data.stage || "",
          location: data.location
            ? { value: data.location.id, label: data.location.name }
            : "",
          village: data.village
            ? { value: data.village.id, label: data.village.name }
            : "",
          vendorName: data.vendorName || "",
          vendorCountryCode: data.vendorCountryCode || "91",
          vendorPhoneNumber: data.vendorPhoneNumber || "",
          mediatorName: data.mediatorName || "",
          mediatorCountryCode: data.mediatorCountryCode || "91",
          mediatorPhoneNumber: data.mediatorPhoneNumber || "",
          traderName: data.traderName || "",
          traderCountryCode: data.traderCountryCode || "91",
          traderPhoneNumber: data.traderPhoneNumber || "",
          images: data.images || [],
          driveLink: data.driveLink || "",
          sketchLink: data.sketchLink || "",
          attachedLink: data.attachedLink || "",
          notes: data.notes || "",
          purchaseType: data.purchaseType || "",
          createdById: data.createdById || userUid || "",
          address: data.address || "",
          locationLink: data?.locationLink || "",
          locationLatitude: data.locationLatitude || "",
          locationLongitude: data.locationLongitude || "",
          primarySourcedBy: data.primarySourcedBy?.id || "",
          secondarySourcedBy: data.secondarySourcedBy?.id || "",
          geoLocation: geoLocationValue,
          overAllSqft: data.overAllSqft || "",
          overAllCent: data.overAllCent || "",
          overAllGround: data.overAllGround || "",
          overAllAcre: data.overAllAcre || "",
          areaRate: data.areaRate || "",
        }));
        setUnits(data.units || []);
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
      showErrorToast("Failed to fetch property data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchGetUnitsByPropertyId = useCallback(
    async (id) => {
      try {
        setLoading(true);
         const body = { propertyId: id, propertyType: propertyTypeName || selectedPropertyDetails?.label || "" };
        const response = await RoughPropertyService.getRoughUnits(body);
        const data = response.data?.data || [];
        setUnits(data?.units || []);
        setUnitTotal(data.totalUnits || 0);
      } catch (error) {
        console.error("Error fetching units data:", error);
      
      } finally {
        setLoading(false);
      }
    },
    [propertyTypeName]
  );

  const handleValidation = () => {
    if(!formData.sittingTitle?.trim()) {
      showErrorToast("Sitting Title is required");
      return false;
    }
    if(!formData.sittingDate) {
      showErrorToast("Sitting Date is required");
      return false;
    }
    if(!formData.sittingTime) {
      showErrorToast("Sitting Time is required");
      return false;
    }
    if(!formData.sittingSpot?.trim()) {
      showErrorToast("Sitting Spot is required");
      return false;
    }
     if(!formData.primarySittingPerson) {
            showErrorToast("Primary Sitting Person is required");
            return false;
          }

    return true;

  }

  const handleFormSubmit = async (status) => {
    if(!handleValidation()) return;

    try {
      const body = {
        propertyId: propertyId,
        nextStage: "sitting",
        sittingData: {
          title: formData.sittingTitle,
          sittingDate: formData.sittingDate,
          sittingTime: formData.sittingTime,
          location: formData.sittingSpot,
          primarySittingPerson: formData.primarySittingPerson?.value,
          secondarySittingPerson: formData.secondarySittingPerson?.value,
          meetingPersonType: formData.meetingPersonType,
          meetingPersonName: formData.meetingPersonName,
          notes: formData.otherNotes,
          createdById: userUid,
        },
        modifiedById: userUid,
      };

      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        fetchGetPropertyById(propertyId);
        setShowSittingForm(false);
        setCurrentStep(3)
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
    setShowSittingForm(false);
  };

 

  const handleMoveToProspect = async () => {
    try {
      const body = {
        propertyId: propertyId,
        nextStage: "prospect",
        modifiedById: userUid,
        documentCameDate: formatDate(fullComeDate),
      };
      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        fetchGetPropertyById(propertyId);

        setIsProspectCreated(false);
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
  };

  const handleMoveToConfirm = async () => {
    try {
      const body = {
        propertyId: propertyId,
        nextStage: "confirm_list",
        modifiedById: userUid,
        documentCameDate: formatDate(fullComeDate),
      };
      const response = await SittingService.moveToNextStage(body);
      const newSitting = response.data;

      if (newSitting) {
        showSuccessToast(newSitting?.message || "Sitting created successfully");
        fetchGetPropertyById(propertyId);

        setIsConfirmed(false);
      }
    } catch (error) {
      console.error("Error creating sitting:", error);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (propertyId) {
      fetchGetPropertyById(propertyId);
    }
  }, [propertyId, fetchGetPropertyById]);

  useEffect(() => {
    if (propertyId && currentStep === 2) {
      fetchGetUnitsByPropertyId(propertyId);
    }
  }, [propertyId, currentStep, fetchGetUnitsByPropertyId]);

  const createPayload = useCallback(() => {
    return {
      propertySaleType: propertyInfo.propertySaleType || null,
      propertyType: propertyInfo.propertyType || null,
      name: propertyInfo.name || null,
      noOfUnits: propertyInfo.noOfUnits ? parseInt(propertyInfo.noOfUnits) : (units.length ? units.length : null),
      propertyEnteredDate: propertyInfo.propertyEnteredDate ? formatDate(propertyInfo.propertyEnteredDate) : null,
      overAllArea: propertyInfo.overAllArea ? parseFloat(propertyInfo.overAllArea) : null,
      overAllAcre: propertyInfo.overAllAcre ? parseFloat(propertyInfo.overAllAcre) : null,
      overAllGround: propertyInfo.overAllGround ? parseFloat(propertyInfo.overAllGround) : null,
      overAllCent: propertyInfo.overAllCent ? parseFloat(propertyInfo.overAllCent) : null,
      overAllSqft: propertyInfo.overAllSqft ? parseFloat(propertyInfo.overAllSqft) : null,
      areaRate: propertyInfo.areaRate ? parseFloat(propertyInfo.areaRate) : null,
      areaType: propertyInfo.areaType || null,
      ratePerSqft: propertyInfo.ratePerSqft ? parseFloat(propertyInfo.ratePerSqft) : null,
      rateInNumber: propertyInfo.rateInNumber ? parseFloat(propertyInfo.rateInNumber) : null,
      overAllBudget: propertyInfo.overAllBudget || null,
      location: propertyInfo.location?.value || null,
      village: propertyInfo.village?.value || null,
      vendorName: propertyInfo.vendorName || null,
     vendorCountryCode: propertyInfo.vendorPhoneNumber  ? propertyInfo.vendorCountryCode : null|| null,
      vendorPhoneNumber: propertyInfo.vendorPhoneNumber || null,
      mediatorName: propertyInfo.mediatorName || null,
      mediatorCountryCode: propertyInfo.mediatorPhoneNumber ? propertyInfo.mediatorCountryCode : null || null,
      mediatorPhoneNumber: propertyInfo.mediatorPhoneNumber || null,
      traderName: propertyInfo.traderName || null,
      traderCountryCode: propertyInfo.traderPhoneNumber ? propertyInfo.traderCountryCode : null || null,
      traderPhoneNumber: propertyInfo.traderPhoneNumber || null,
      images: propertyInfo.images?.length ? propertyInfo.images : null,
      driveLink: propertyInfo.driveLink || null,
      sketchLink: propertyInfo.sketchLink || null,
      attachedLink: propertyInfo.attachedLink || null,
      notes: propertyInfo.notes || null,
      purchaseType: propertyInfo.purchaseType || null,
      createdById: userUid || null,
      address: propertyInfo.address || null,
      locationLink: propertyInfo.locationLink || null,
      locationLatitude: propertyInfo.geoLocation
        ? Number(propertyInfo.geoLocation.split(",")[0].trim())
        : propertyInfo.locationLatitude || null,
      locationLongitude: propertyInfo.geoLocation
        ? Number(propertyInfo.geoLocation.split(",")[1].trim())
        : propertyInfo.locationLongitude || null,
      primarySourcedBy: propertyInfo.primarySourcedBy || null,
      secondarySourcedBy: propertyInfo.secondarySourcedBy || null,
    };
  }, [propertyInfo, units]);

  const propertyInfoValidation = () => {
    if (!propertyInfo.name?.trim()) {
      showErrorToast("Property Name is required");
      return false;
    }
    if (!propertyInfo.overAllAcre && !propertyInfo.overAllGround && !propertyInfo.overAllCent && !propertyInfo.overAllSqft) {
       showErrorToast("At least one rate field is required (sqft, cent, ground, acres)");
      return false;
    }
    if (!propertyInfo.areaType?.trim()) {
      showErrorToast("Area Type is required");
      return false;
    }
    if (!propertyInfo.areaRate) {
      showErrorToast("Area Rate is required");
      return false;
    }
    if (!propertyInfo.overAllBudget?.trim()) {
      showErrorToast("Overall Budget is required");
      return false;
    }
    
    if (!propertyInfo.primarySourcedBy?.trim()) {
      showErrorToast("Primary Sourced is required");
      return false;
    }
    if (!propertyInfo.location?.value) {
      showErrorToast("Location is required");
      return false;
    }
    
  
    
    return true;
  };

  

  const handleSaveOrUpdateProperty = async () => {
    setLoading(true);
    const payload = createPayload();

    
    try {
      let response;
      if (createdPropertyId) {
        const updatedPayload = { ...payload, modifiedById: userUid || null };
        response = await RoughPropertyService.updateRoughProperty(
          createdPropertyId,
          updatedPayload
        );
      } else {
        response = await RoughPropertyService.createRoughProperty(payload);
      }
      if (response.status === 200 || response.status === 201) {
        const newPropertyId =
          response.data?.id || response.data?.data?.id || createdPropertyId;
        if (!createdPropertyId && newPropertyId) {
          setCreatedPropertyId(newPropertyId);
        }
        showSuccessToast(
          createdPropertyId
            ? "Property updated successfully!"
            : response.data?.message || "Property created successfully!"
        );
        if (currentStep === 1) {
          setCurrentStep(2);
        }
      }
    } catch (error) {
      console.error(
        `Error ${createdPropertyId ? "updating" : "saving"} property:`,
        error
      );
      showErrorToast(
        error.response?.data?.message ||
          `Failed to ${
            createdPropertyId ? "update" : "save"
          } property. Please try again.`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSaveUnits = async () => {
    if (!createdPropertyId) {
      showErrorToast("Please save the property first");
      return;
    }

    if (units.length === 0) {
      showErrorToast("Please add at least one unit");
      return;
    }

    setLoading(true);
    try {
      // Separate new units from existing units based on ID and locally created flag
      const newUnits = units.filter((unit) => 
        (!unit.id || unit.id === null) && unit.isLocallyCreated !== false
      );
      const existingUnits = units.filter((unit) => 
        unit.id && unit.id !== null && !unit.isLocallyCreated
      );

      console.log("New units to create:", newUnits);
      console.log("Existing units to update:", existingUnits);

      let response;

      let newUnitsSaved = false;
      let existingUnitsUpdated = false;

      // Handle new units - create them
      if (newUnits.length > 0) {
        const createUnitsPayload = {
          propertyId: createdPropertyId,
          propertyType: propertyTypeName || selectedPropertyDetails?.label,
          unitsData: newUnits.map((unit, index) => ({
            order: unit.order || index + 1,
            unitNo: unit.unitNo || "",
            sqft: Number(unit.sqft) || 0,
            ratePerSqft: Number(unit.ratePerSqft) || 0,
            governmentGuideline: Number(unit.governmentGuideline) || 0,
            vendorGuideline: Number(unit.vendorGuideline) || 0,
            northDimension: String(unit.northDimension || ""),
            eastDimension: String(unit.eastDimension || ""),
            westDimension: String(unit.westDimension || ""),
            southDimension: String(unit.southDimension || ""),
            roadFacing: unit.roadFacingSide?.name || unit.roadFacing || "",
            roadWidth: String(unit.roadWidth || ""),
            registrationCharge: Number(unit.registrationCharge) || 0,
            preferredLocationCharge: Number(unit.preferredLocationCharge) || 0,
            unitStatusId: availableId,
            createdBy: userUid,
            modifiedBy: userUid,
            notes: unit.notes || "",
            propertyId: createdPropertyId,
          })),
        };

        response = await RoughPropertyService.createRoughUnits(
          createdPropertyId,
          createUnitsPayload
        );
        if (response.status === 200 || response.status === 201) {
          newUnitsSaved = true;
        }
      }

      if (existingUnits.length > 0) {
        const updateUnitsPayload = {
          propertyId: createdPropertyId,
          propertyType: propertyTypeName || propertyInfo.propertyTypeName || "",
          unitsData: existingUnits.map((unit, index) => ({
            docId: unit.id,
            order: unit.order || index + 1,
            unitNo: unit.unitNo || "",
            sqft: Number(unit.sqft) || 0,
            ratePerSqft: Number(unit.ratePerSqft) || 0,
            governmentGuideline: Number(unit.governmentGuideline) || 0,
            vendorGuideline: Number(unit.vendorGuideline) || 0,
            northDimension: String(unit.northDimension || ""),
            eastDimension: String(unit.eastDimension || ""),
            westDimension: String(unit.westDimension || ""),
            southDimension: String(unit.southDimension || ""),
            roadFacing: unit.roadFacingSide?.name || unit.roadFacing || "",
            roadWidth: String(unit.roadWidth || ""),
            registrationCharge: Number(unit.registrationCharge) || 0,
            preferredLocationCharge: Number(unit.preferredLocationCharge) || 0,
            modifiedBy: userUid,
            notes: unit.notes || "",
            propertyId: createdPropertyId,
          })),
        };

        response = await RoughPropertyService.updateRoughUnits(
          createdPropertyId,
          updateUnitsPayload
        );
        if (response.status === 200 || response.status === 201) {
          existingUnitsUpdated = true;
        }
      }

      if (!newUnitsSaved && !existingUnitsUpdated) {
        showErrorToast("No units to save or update");
      } else {
        showSuccessToast(
          "Units updated and/or created successfully"
        );
      }

      // If both operations completed successfully or at least one was executed
      if (newUnits.length === 0 && existingUnits.length === 0) {
        showErrorToast("No units to save");
        return;
      }

      // Refresh the units data after successful save/update
      await fetchGetUnitsByPropertyId(createdPropertyId);

    
    } catch (error) {
      console.error("Error saving units:", error);
     
    } finally {
      setLoading(false);
    }
  };

 const handleNextStep = () => {
  const isValid = propertyInfoValidation();

  if (currentStep === 1) {
    if (!isValid) return;
   
          handleSaveOrUpdateProperty();
    
    return;
  }

  if (currentStep === 2) {
  
    handleSaveUnits();
    return;
  }

  if (currentStep === 3) {
    showSuccessToast("All information saved successfully!");
    setTimeout(() => navigate(-1), 1500);
  }
};


  const confirmNextStep = async () => {
    setShowConfirmModal(false);
    await handleSaveOrUpdateProperty();
  };

  let steps = [];

  if (propertyId && propertyInfo?.propertyStage !== "Rough Draft") {
    steps = [
      { id: 1, label: "Basic Info", action: () => setCurrentStep(1),validation: propertyInfoValidation, },
      { id: 2, label: "Unit Info", action: () => setCurrentStep(2) },
      { id: 3, label: "Sitting Info", action: () => setCurrentStep(3) },
    ];
  } else {
    steps = [
      { id: 1, label: "Basic Info", action: () => setCurrentStep(1), validation: propertyInfoValidation, },
      { id: 2, label: "Unit Info", action: () => setCurrentStep(2) },
      //  { id: 3, label: "Sitting Info", action: () => setCurrentStep(3) },
    ];
  }

  return (
    <div className="bg-appGrayBackground min-h-screen pb-14">
      <Header />
      <ToastContainer />
      <div className="pt-28 px-6 pb-10">
        <div className="flex items-center justify-between mb-5">
          <CustomHeading
            title={
              <>
                {propertyName ? `${propertyName}` : "Add New Property"}
                <span className="text-blue-500  text-lg">
                  {propertyInfo?.propertyStage
                    ? ` - ${propertyInfo?.propertyStage}`
                    : ""}
                </span>
              </>
            }
            isIcon={true}
          />
          <div className="flex gap-3">
            {propertyId && (
              <CustomButton
                label={"Rough Draft History"}
                onClick={() =>
                  navigate("/procurement-raughDraft/rough-property-history", {
                    state: { propertyId: propertyId, propertyName: propertyName },
                  })
                }
                customStyles="text-gray-700 bg-white border border-gray-300 px-6 py-3 rounded-lg hover:bg-gray-100"
              />
            )}
             {currentStep !== 3 && (
                          <CustomButton
                            label={currentStep === 1 ? "Save & Next" : "Save Units & Next"}
                            onClick={handleNextStep}
                            isDisabled={loading}
                            customStyles="text-white bg-customGreen px-6 py-3 rounded-lg hover:bg-green-600"
                          />
                        )}
            
            {propertyInfo?.propertyStage === "Rough Draft" && (
              <CustomButton
                onClick={() => {
                  setShowSittingForm(true);
                  setEditingSitting(null);
                }}
                label="Move to In Sitting Stage"
                customStyles="text-gray-700 bg-white border border-gray-300 px-6 py-3 rounded-lg hover:bg-gray-100"
              />
            )}
            {propertyInfo?.propertyStage === "In Sitting" && (
              <CustomButton
                label="Move to Prospect Stage"
                onClick={() => {
                  setIsProspectCreated(true);
                  setIsConfirmed(false);
                }}
                customStyles="text-gray-700 bg-white border border-gray-300 px-6 py-3 rounded-lg hover:bg-gray-100"
              />
            )}
            {propertyInfo?.propertyStage === "In Prospect" && (
              <CustomButton
                label="Move to In Confirmation Stage"
                onClick={() => {
                  setIsConfirmed(true);
                }}
                customStyles="text-gray-700 bg-white border border-gray-300 px-6 py-3 rounded-lg hover:bg-gray-100"
              />
            )}
          </div>
        </div>
        <div className="bg-white rounded-[10px] py-6 px-3 relative">
          <PropertyStepProgress
            currentStep={currentStep}
            variant={createdPropertyId ? "edit" : "create"}
            steps={steps}
           
          />
          {currentStep === 1 && (
            <div className="p-6">
              <RoughPropertyInfoBasic
                propertyInfo={propertyInfo}
                setPropertyInfo={setPropertyInfo}
                handlePropertyInfoChange={handlePropertyInfoChange}
                handleArrayFieldChange={handleArrayFieldChange}
                isEdit={createdPropertyId}
                propertyType="layout"
              />
            </div>
          )}
          {currentStep === 2 && (
            <div className="p-6">
              <UnitInfo
                tableRows={units}
                onAdd={handleAddUnit}
                onEdit={handleEditUnit}
                formatINR={formatINR}
                formatINRShort={formatINRShort}
                getStatusStyles={getStatusStyles}
                propertyId={createdPropertyId}
              />
            </div>
          )}
          {currentStep === 3 && (
            <div className="p-6">
              <SittingInfo propertyId={propertyId} />
            </div>
          )}
        </div>

        <ReusableSittingForm
          visible={showSittingForm}
          editingSitting={editingSitting}
          setFormData={setFormData}
          onHide={() => setShowSittingForm(false)}
          onSubmit={handleFormSubmit}
          formData={formData}
          onChange={handleFormChange}
          title="Sitting"
          sidebarWidth="600px"
          showAdvancedButtons={true}
          customButtonLogic={(formData) => {
            const isUpcomingOrNoUpdate = 
              formData?.isCompleted === "Up Coming" || 
              formData?.isCompleted === "No Update";
            
            const isNotCompletedOrCancelled = 
              formData.isCompleted !== "COMPLETED" && 
              formData.isCompleted !== "CANCELLED";
            
            const canShowAdvancedButtons = 
              formData.stage !== "completed" && 
              formData.stage !== "cancelled";

            return {
              showPrimaryButton: (isUpcomingOrNoUpdate && canShowAdvancedButtons) || isNotCompletedOrCancelled,
              showCompletedButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
              showCancelButton: isUpcomingOrNoUpdate && canShowAdvancedButtons,
            };
          }}
        />
        <ConfirmationModal
          showModal={showConfirmModal}
          title="Date Field are non editable"
          message="Once you create the property, the date field cannot be edited. Make sure to enter the correct dates."
          content={
            <>
              <div>
                <p className="text-sm text-gray-600">
                  Property Entered Date :{" "}
                  {formatDate(propertyInfo.propertyEnteredDate) || "N/A"}
                </p>
              </div>
            </>
          }
          onConfirm={confirmNextStep}
          onCancel={() => setShowConfirmModal(false)}
        />

        <ConfirmationModal
          showModal={isProspectCreated}
          title="Are You Sure ?"
          message="Are you sure you want to move to the In Prospect Stage?"
          additionalProp={false}
          content={
            <>
              <div>
                <p className="text-sm text-gray-600">
                  Select the Full Doc Came date for this property
                </p>
                <input
                  type="date"
                  name="fullDocCameDate"
                  value={fullComeDate}
                  onChange={(e) => {
                    setFullComeDate(e.target.value);
                  }}
                  className="mt-2 p-2 border border-gray-300 rounded-md w-full"
                />
              </div>
              <div className="flex justify-center gap-3 ">
                <button
                  onClick={() => {
                    setIsProspectCreated(false);
                    setIsConfirmed(false);
                  }}
                  className="mt-4 mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md "
                >
                  Cancel
                </button>
                <button
                  disabled={!fullComeDate}
                  onClick={() => {
                    handleMoveToProspect();
                  }}
                  className={`mt-4 px-4 py-2 text-white rounded-md ${
                    fullComeDate
                      ? "bg-customGreen cursor-pointer"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                >
                  Confirm
                </button>
              </div>
            </>
          }
        />

        <ConfirmationModal
          showModal={isConfirmed}
          title="Are You Sure ?"
          message="Are you sure you want to move to the In Confirmation Stage?"
          additionalProp={false}
          content={
            <>
              <div>
                <p className="text-sm text-gray-600">
                  Select the Full Doc Came date for this property
                </p>
                <input
                  type="date"
                  name="fullDocCameDate"
                  value={fullComeDate}
                  onChange={(e) => {
                    setFullComeDate(e.target.value);
                  }}
                  className="mt-2 p-2 border border-gray-300 rounded-md w-full"
                />
              </div>
              <div className="flex justify-center gap-3 ">
                <button
                  onClick={() => {
                    setIsProspectCreated(false);
                    setIsConfirmed(false);
                  }}
                  className="mt-4 mr-2 px-4 py-2 bg-gray-300 text-gray-700 rounded-md "
                >
                  Cancel
                </button>
                <button
                  disabled={!fullComeDate}
                  onClick={() => {
                    handleMoveToConfirm();
                  }}
                  className={`mt-4 px-4 py-2 text-white rounded-md ${
                    fullComeDate
                      ? "bg-customGreen cursor-pointer"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
                >
                  Confirm
                </button>
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};

export default RoughPropertyInfoPage;
